export default {
  styleOverrides: {
    root: {
      padding: '20px 24px'
    }
  }
};
